export default {
  flows: {},
  referrers: [],
  clients: {
    byId: {},
    allIds: []
  },
  currentAgent: "",
  totalClients: null,
  applicationCount: "",
  clientsTableFilters: {
    orderBy: "",
    orderType: "",
    searchString: "",
    status: null,
    board: null,
    read: null
  },
  applications: {
    byId: {}
  },
  import: {
    verificationEmail: "",
    shouldVerifyEmail: false
  }
};